var _path, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtVideoPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 184,
    viewBox: "0 0 184 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.4609 64.5504C73.4609 62.413 75.7746 61.0772 77.6256 62.1459L125.52 89.7977C127.371 90.8664 127.371 93.5381 125.52 94.6068L77.6256 122.259C75.7746 123.327 73.4609 121.991 73.4609 119.854L73.4609 64.5504Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_biiii_325_2690)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 92,
    r: 92,
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 92,
    r: 90.5,
    stroke: "url(#paint0_radial_325_2690)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 92,
    r: 90.5,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 3
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4609 64.5504C73.4609 62.413 75.7746 61.0772 77.6256 62.1459L125.52 89.7977C127.371 90.8664 127.371 93.5381 125.52 94.6068L77.6256 122.259C75.7746 123.327 73.4609 121.991 73.4609 119.854L73.4609 64.5504Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_biiii_325_2690",
    x: -12.6293,
    y: -12.6293,
    width: 209.259,
    height: 209.259,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.31467
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_325_2690"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_325_2690",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.70667,
    dy: 1.70667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.853333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8 0 0 0 0 0.8 0 0 0 0 0.8 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_325_2690"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.853333,
    dy: 0.853333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.426667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_325_2690",
    result: "effect3_innerShadow_325_2690"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.70667,
    dy: -1.70667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.853333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_325_2690",
    result: "effect4_innerShadow_325_2690"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.853333,
    dy: -0.853333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.426667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8 0 0 0 0 0.8 0 0 0 0 0.8 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_innerShadow_325_2690",
    result: "effect5_innerShadow_325_2690"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_325_2690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.5 -8.5) rotate(68.5845) scale(206.776)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtVideoPlayIcon);
export default __webpack_public_path__ + "static/media/art-video-play-icon.d31ffeef6951865220ecbbbb0933ad4b.svg";
export { ForwardRef as ReactComponent };